// --- START PATCH: Improve invalid-state visibility in dark mode (ring + lighter bg + readable text) ---
import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // Focus
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        // Invalid (increase contrast and clarity in dark mode)
        "aria-invalid:text-foreground",
        "aria-invalid:ring-2 aria-invalid:ring-destructive/30", // show ring even when not focused
        "aria-invalid:border-destructive",
        "aria-invalid:bg-muted/10 aria-invalid:dark:bg-muted/20", // slightly lighter background so input doesn't disappear on dark
        className
      )}
      {...props}
    />
  )
}

export { Input }
// --- END PATCH: Improve invalid-state visibility in dark mode (ring + lighter bg + readable text) ---